/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { useState } from 'react';
import NavLogo from '../assets/white-logo.png';
import '../styles/NavBar.css';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Turn as Hamburger } from 'hamburger-react'
import CaretDown from '../assets/caret-down-svg.svg'
import HamburgerLinkArrow from '../assets/hamburger_link-arrow.svg'

const NavBar = () => {
    const [displayDropdownData, setDisplayDropdownData] = useState(true);
    const [isOpen, setOpen] = useState(false)
    const location = useLocation();
    const isNewsPage = !location.pathname.endsWith('/news');

    const dropdownData = [
        { title: 'Register with Amderon', url: '/register' },
        { title: 'Our Star Lawyers', url: '/star-lawyers' }
    ];

    const hamburgerLinks = [
        { title: 'Register with Amderon', url: '/register' },
        { title: 'Our Star Lawyers', url: '/star-lawyers' },
        { title: 'Our Services', url: '/services' },
        { title: 'About Us', url: '/about' },
        { title: 'Contact Us', url: '/contact' },
    ]

    const toggleDropdown = () => {
        setDisplayDropdownData(prevState => !prevState);
    };

    const toggleHamburger = () => {
        setOpen(!isOpen)
    }

    const closeDropdownHamburger = () => {
        setDisplayDropdownData(true);
        setOpen(false);
    }

    return (
        <div className="nav_wrapper">
            <nav>
                <Link to='/' className='nav_logo-link' onClick={closeDropdownHamburger}>
                    <img src={NavLogo} alt="Amderon Enterprise" className="nav_logo" />
                </Link>
                <ul className="nav_link-list">
                    <li className='nav_dropdown-parent'>
                        <span onClick={toggleDropdown} className={`nav_dropdown-button ${displayDropdownData ? 'active' : ''}`} >
                            Lawyer Zone <img src={CaretDown} alt='' style={{ marginLeft: '4px', marginTop: '1px' }} />
                        </span>
                        <ul className={`nav_dropdown-data ${displayDropdownData ? 'active' : ''}`}>
                            {dropdownData.map((dropdownItem, index) => (
                                <li key={index} onClick={toggleDropdown}>
                                    <Link to={dropdownItem.url} className='nav_link nav_dropdown-link'>{dropdownItem.title}</Link>
                                </li>
                            ))}
                        </ul>
                    </li>
                    <li>
                        <Link to='/services' className='nav_link' onClick={closeDropdownHamburger}>Our Services</Link>
                    </li>
                    <li>
                        <Link to='/about' className='nav_link' onClick={closeDropdownHamburger}>About Us</Link>
                    </li>
                    <li>
                        <Link to='/contact' className='nav_link' onClick={closeDropdownHamburger}>Contact Us</Link>
                    </li>
                </ul>
                <div className="hamburger_navbar">
                    <Hamburger toggled={isOpen} toggle={setOpen} color='white' rounded />
                    <ul className="hamburger_link-list">
                        {
                            isOpen && hamburgerLinks.map((navLink, index) => {
                                return (
                                    <li key={index} className='hamburger_link-item' onClick={toggleHamburger}>
                                        <Link to={navLink.url} className={`hamburger_link ${index === 0 ? 'hamburger_link-primary' : ''}`}>{navLink.title}</Link>
                                        <img src={HamburgerLinkArrow} alt="" className="hamburger_link-svg" />
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            </nav>
            {isNewsPage && (
                <Link to='/news' className="ticker_wrapper">
                    <div className="ticker">
                        <span>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing</span>
                        <span>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing</span>
                    </div>
                </Link>
            )}
        </div>
    );
}

export default NavBar;